// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardsWrapper_wrapper__166Jf"};